const UserRoleGroupEnum = {
  "OWNER": "Owner",
  "ADMIN_PRO": "Administrator - Account",
  "ADMIN_BASIC": "Administrator - Limited",
  "SUBSCRIBER_PRO": "Subscriber - Pro",
  "SUBSCRIBER_BASIC": "Subscriber - Basic",
  "GUEST": "Guest",
};

export default UserRoleGroupEnum;